import { render } from "./CreateNewTopicModal.vue?vue&type=template&id=1b6ee0c4&scoped=true"
import script from "./CreateNewTopicModal.vue?vue&type=script&lang=js"
export * from "./CreateNewTopicModal.vue?vue&type=script&lang=js"

import "./CreateNewTopicModal.vue?vue&type=style&index=0&id=1b6ee0c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6ee0c4"]])

export default __exports__